<template>
  <el-dialog
    title="上传素材"
    :visible.sync="visible"
    width="386px"
    :before-close="handleClose"
  >
    <div class="select-box">
      <div class="select-text">选择分类</div>
      <el-select
        class="frist-select"
        v-model="firstId"
        size="medium"
        @change="handleChange"
      >
        <el-option
          v-for="item in firstList"
          :key="item.sort_id"
          :value="item.sort_id"
          :label="item.sort_name"
        ></el-option>
      </el-select>
      <el-select
        class="second-select"
        v-model="secondId"
        size="medium"
        v-if="type === '2'"
      >
        <el-option
          v-for="item in secondList"
          :key="item.sort_id"
          :value="item.sort_id"
          :label="item.sort_name"
        ></el-option>
      </el-select>
    </div>
    <ImageUploader
      v-on:uploaded="handleUpload"
      className="upload-image-btn-box"
      class="uplaod-box"
      :before-upload="beforeAvatarUpload"
    >
    </ImageUploader>
  </el-dialog>
</template>
<script>
import ImageUploader from "@/components/ImageUploaderMultiple.vue";
import { getSortList, getCommonList } from "../../common.js";
export default {
  components: { ImageUploader },
  props: {
    visible: {
      type: Boolean,
      require: true
    },
    type: {
      type: String, // 1 个人空间 2 共享空间
      require: true
    },
    category: {
      type: Array, // number[]
      default: ()=>[]
    }
  },
  data() {
    return {
      isUpload: false,
      firstId: null,
      firstList: [],
      secondId: null,
      secondList: []
    };
  },
  computed: {
    saveImgApi() {
      if (this.type === "1") {
        return "api/test/images/add"; // url sort_id分类ID
      } else if (this.type === "2") {
        return "api/test/material/add";
      }
      return "";
    }
  },
  created() {
    this.init();
  },
  methods: {
    isEmpty(value) {
      return value === undefined || value === null || value === ''
    },
    /** 上传前 */
    beforeAvatarUpload() {
      let isSelectId = true
      if(this.type === '1') {
        if(this.isEmpty(this.firstId)) {
          isSelectId = false
        }
      } else if(this.type === '2') {
        if(this.isEmpty(this.secondId)) {
          isSelectId = false
        }
      }
      if(isSelectId === false) {
        this.$message.error('请选择分类')
      }
      return isSelectId
    },
    // 初始化
    async init() {
      if (this.type === "1") {
        this.firstList = await getSortList();
      } else if (this.type === "2") {
        this.firstList = await getCommonList();
      }
      this.initSelect()
    },
    /** 初始化选择分类 */
    async initSelect() {
      const current = this.getCurrentCategory(this.category[0], this.firstList, 'sort_id')
      if(current !== null) {
        this.firstId = current.sort_id
        const list = await this.handleChange()
        const secondCurrent = this.getCurrentCategory(this.category[1], list, 'sort_id')
        if(secondCurrent !== null) {
          this.secondId = secondCurrent.sort_id
        }
      }
    },
    /** 通过ID查询分类 */
    getCurrentCategory(id, list, key) {
      let current = null
      if(!this.isEmpty(id) && Array.isArray(list)) {
        list.some(item=>{
          if(item[key] === id) {
            current = item
            return true
          }
        })
      }
      return current
    },
    async handleChange() {
      if (this.type === "2") {
        this.secondId = "";
        this.secondList = [];
        try {
          this.secondList = await getCommonList(this.firstId);
        } catch (error) {
          // error
        }
      }
      return this.secondList
    },
    checkUploadParams(params) {
      const selectId = () => {
        this.$message.error('请选择分类')
      }
      if (this.type === "1") {
        if(this.isEmpty(params.sort_id)) {
          selectId()
          return false
        }
      } else if (this.type === "2") {
        if(this.isEmpty(params.category_id)) {
          selectId()
          return false
        }
      }
      return true;
    },
    /** oss后保存 */
    handleUpload(srcList, fileName) {
      const params = {
        url: srcList,
      };
      if (this.type === "1") {
        params.sort_id = this.firstId;
        params.name = fileName;
      } else if (this.type === "2") {
        params.category_id = this.secondId;
        params.material_name = fileName;
      }
      const valid = this.checkUploadParams(params);
      if (valid === false) return;
      lib.tmsapi.post({
        api: this.saveImgApi,
        data: params,
        success: res => {
          // 提示成功
          this.$message.success({
            message: "添加图片成功",
            type: "info",
            center: true
          });

          this.isUpload = true
          this.handleClose()
        }
      });
    },
    handleClose() {
      this.$emit('close', this.isUpload)
      this.$emit("update:visible", false);
    }
  }
};
</script>
<style scoped>
.uplaod-box /deep/ .el-upload-dragger {
  width: 338px;
  height: 217px;
}
.select-box {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.select-text {
  flex-shrink: 0;
  color: #333;
  margin-right: 16px;
}
.frist-select {
  width: 170px;
  margin-right: 12px;
}
.second-select {
  width: 144px;
}
</style>
